<template>
  <transition name="slide-fade">
    <div
      id="cookies-warning"
      v-cloak
      v-if="showMsg"
      :class="{ center: position === 'center' }"
      :style="{ backgroundColor: bgColor, color: color }"
    >
      <div>
        <p>
          <slot name="text"> By using this website, you agree to our </slot>
          <slot name="modal-link">
            <button type="button" :style="{ color: color }">
              cookies policy.
            </button>
          </slot>
        </p>
      </div>
      <button
        type="button"
        class="cookies-close"
        @click="setMsgCookie(false)"
        :style="{ color: color, borderColor: color }"
      >
        <slot name="close">Agree</slot>
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      default: "left",
      required: false,
    },
    bgColor: {
      type: String,
      default: "#000",
      required: false,
    },
    color: {
      type: String,
      default: "#fff",
      required: false,
    },
  },
  data() {
    return {
      showMsg: false,
    };
  },
  methods: {
    getMsgCookie() {
      return (
        this.$cookies.get("showCookiesMsg") == "true" ||
        this.$cookies.get("showCookiesMsg") == null
      );
    },
    setMsgCookie(value) {
      this.$cookies.set("showCookiesMsg", value, "1m");
      this.showMsg = value;
    },
  },
  mounted() {
    this.showMsg = this.getMsgCookie();
  },
};
</script>

<style lang="scss">
#cookies-warning {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 260px;
  max-width: 100%;
  padding: 40px 40px;
  z-index: 2001;
  font-size: 0.9rem;
  text-align: center;

  button {
    text-align: left;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  .cookies-close {
    margin-top: 1rem;
    text-decoration: none;
    padding: 5px 30px;
    border: 1px solid;
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 250ms ease-out;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>